import { NgModule } from '@angular/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import {
  DropDownListModule,
  DropDownsModule,
  DropDownTreesModule,
  MultiSelectModule,
} from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import {
  IndicatorsModule,
  LoaderModule,
} from '@progress/kendo-angular-indicators';
import {
  CheckBoxModule,
  FormFieldModule,
  MaskedTextBoxModule,
  NumericTextBoxModule,
  RadioButtonModule,
  SwitchModule,
  TextAreaModule,
  TextBoxModule,
} from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import {
  GridLayoutModule,
  LayoutModule,
  StepperModule,
} from '@progress/kendo-angular-layout';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { ContextMenuModule } from '@progress/kendo-angular-menu';
import { PagerModule } from '@progress/kendo-angular-pager';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { TreeListModule } from '@progress/kendo-angular-treelist';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { InputsModule } from '@progress/kendo-angular-inputs';

@NgModule({
  imports: [
    ButtonsModule,
    CheckBoxModule,
    ContextMenuModule,
    DateInputsModule,
    DialogsModule,
    DropDownListModule,
    DropDownTreesModule,
    FormFieldModule,
    GridLayoutModule,
    GridModule,
    IconsModule,
    IndicatorsModule,
    LabelModule,
    LayoutModule,
    LoaderModule,
    MaskedTextBoxModule,
    MultiSelectModule,
    PagerModule,
    NumericTextBoxModule,
    RadioButtonModule,
    StepperModule,
    SwitchModule,
    TextAreaModule,
    TextBoxModule,
    TooltipsModule,
    TreeListModule,
    DropDownsModule,
    LayoutModule,
    PopupModule,
    UploadsModule,
    ListViewModule,
    InputsModule,
  ],
  exports: [
    ButtonsModule,
    CheckBoxModule,
    ContextMenuModule,
    DateInputsModule,
    DialogsModule,
    DropDownListModule,
    DropDownTreesModule,
    FormFieldModule,
    GridLayoutModule,
    GridModule,
    IconsModule,
    IndicatorsModule,
    PagerModule,
    LabelModule,
    LayoutModule,
    LoaderModule,
    MaskedTextBoxModule,
    MultiSelectModule,
    NumericTextBoxModule,
    RadioButtonModule,
    StepperModule,
    SwitchModule,
    TextAreaModule,
    TextBoxModule,
    TooltipsModule,
    TreeListModule,
    DropDownsModule,
    LayoutModule,
    PopupModule,
    UploadsModule,
    ListViewModule,
    InputsModule,
  ],
})
export class KendoUIModule {}
